import { CallStateDirection } from '../types';

interface CallsCacheData {
  orientation: CallStateDirection;
  timestamp: string;
  callId: string;
}

// This cache stores minimal call data (direction, timestamp, and remoteCallId) for recently changed calls.
// It is necessary because when a call fails, the call list may have already removed the call
// by the time the "call-failed" event is processed. We use this cache to:
// 1. Determine if a failed call was outbound, so we can display the appropriate toast notification
export const callsCache = new Map<string, Omit<CallsCacheData, 'callId'>>();

export function cacheCall({
  callId,
  orientation,
  timestamp,
}: CallsCacheData): void {
  // clean up entries older than 10 minutes when the map reaches 100 records
  const MAX_MAP_SIZE = 100;
  const TTL = 10 * 60 * 1000;
  if (callsCache.size >= MAX_MAP_SIZE) {
    const currentTime = new Date().getTime();

    for (const [id, data] of callsCache.entries()) {
      const timestampDate = new Date(data.timestamp).getTime();
      if (currentTime - timestampDate > TTL) {
        callsCache.delete(id);
      }
    }
  }

  callsCache.set(callId, { orientation, timestamp });
}

export function isCallOutbound(callId: string): boolean {
  const callData = callsCache.get(callId);
  if (!callData) {
    return false;
  }
  return callData.orientation === 'originating';
}

export function hasCachedCall(callId: string): boolean {
  return callsCache.has(callId);
}
